/**
 * 预览子组件-前置预览组件
 * @author chenqunfeng
 * @since 17/11/04
 */

import QRCode from '@fe/common/lib/qrcode';
import { getUrlWithHttpsProtocol } from '@fe/common/lib/url';
import Logger from '@fe/logger';
import { getShortUrl } from 'api/common';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import store from 'store';
import * as url from '@fe/common/lib/url';
import * as qs from '@fe/common/lib/query-string';
import { isShowStoreTemplateQRCode, showRabbitBrandInfo } from 'utils/user';
import './forward-view.less';

const logger = Logger.get('store:forward-view');

class PreviewForwardView extends Component {
  static propTypes = {
    data: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      multipleTitle: false,
      multipleDesc: false,
    };
    this.titleRef = React.createRef();
    this.descRef = React.createRef();
    this.qrCode = React.createRef();
    // 二维码对象实例
    this.qrCodeInstance = null;
  }

  componentDidMount() {
    this.setTextStyle();
    this.initQrCode();
  }

  componentWillUnmount() {
    if (this.qrCodeInstance) {
      // 清除二维码对象实例
      this.qrCodeInstance.clear();
      this.qrCodeInstance = null;
    }
  }

  /**
   * 渲染二维码
   *
   * @memberof PreviewForwardView
   */
  async initQrCode() {
    const isShow = isShowStoreTemplateQRCode();
    if (!isShow) return;
    const url = await this.getQrCodeUrl();
    this.qrCodeInstance = new QRCode(this.qrCode, {
      text: url,
      width: 100,
      height: 100,
      colorDark: '#000000',
      colorLight: '#ffffff',
    });
  }

  /**
   * 获取预览二维码链接（短链）
   *
   * @memberof PreviewForwardView
   */
  async getQrCodeUrl() {
    const { data } = this.props;
    const userState = store.getState();
    const { previewUrl } = data;

    // 显式声明mobile和autoplay
    const query = qs.parse(previewUrl);
    const urlObj = url.parse(previewUrl);
    const { path = '', hostWidthPort = '' } = urlObj;
    query.mobile = 1;
    query.autoplay = 1;
    query.hideTemplateLoadingLogo = showRabbitBrandInfo() ? false : true;
    if (userState && userState.userInfo) {
      query.userOpfId = userState.userInfo.userOpfId;
      query.userPfid = userState.userInfo.userPfid;
    }

    let qrCodeUrl = '//' + hostWidthPort + path + '?' + qs.stringify(query);

    try {
      qrCodeUrl = await getShortUrl(getUrlWithHttpsProtocol(qrCodeUrl));
    } catch (err) {
      logger.error(err);
    }

    return qrCodeUrl;
  }

  /**
   * 设置标题、描述的样式
   */
  setTextStyle() {
    const titleHeight = this.titleRef ? this.titleRef.current.offsetHeight : 0;
    const descHeight = this.descRef ? this.descRef.current.offsetHeight : 0;
    this.setState({
      multipleTitle: !!(titleHeight > 28 * 2),
      multipleDesc: !!(descHeight > 18 * 5),
    });
  }

  // 渲染正版标题
  renderCopyright() {
    return <span className="s-preview-copyright">正版</span>;
  }

  /**
   * 渲染预览二维码
   */
  renderQRCode() {
    const { type } = this.props.data;
    const isShow = isShowStoreTemplateQRCode();
    if (!isShow) return null;
    return (
      <div
        className={`s-preview-qrcode ${
          type === 'POSTER' ? 'is-poster-modal' : ''
        } `}>
        <div ref={qrCode => (this.qrCode = qrCode)}></div>
        <div className="s-preview-qrcode-tips">微信扫码预览模版</div>
      </div>
    );
  }

  render() {
    const { title, desc, materials } = this.props.data;
    const { multipleTitle, multipleDesc } = this.state;

    const titleClass = `s-preview-title ${
      multipleTitle ? 'multiple-line' : ''
    }`;
    const descClass = `s-preview-desc ${multipleDesc ? 'multiple-line' : ''}`;
    return (
      <div className="s-preview-forward-view">
        <h2 ref={this.titleRef} className={titleClass}>
          {`${title}` || '--'}
        </h2>
        {materials > 0 && this.renderCopyright()}
        <div className="s-preview-desc-box">
          <div ref={this.descRef} className={descClass}>
            {desc || '--'}
          </div>
          {this.renderQRCode()}
        </div>
      </div>
    );
  }
}

export default PreviewForwardView;
